import ApplicationResource from './ApplicationResource';
import { Content } from "./Content";
export default class AdminFormResource extends ApplicationResource {
    constructor() {
        super(...arguments);
        this.name = "Formulaire sans nom";
        this.content = new Content();
    }
    pk() {
        return this.slug;
    }
}
AdminFormResource.resource = '/forms/definitions';
//# sourceMappingURL=AdminFormResource.js.map